/**
 * Возвращает последний элемент массива
 */
export const last = <T extends unknown[]>(arr: T): T[number] | undefined => {
    const [lastItem] = arr.slice(-1);
    return lastItem;
};

export default last;
